import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/utils/registerServiceWorker";
import { clearAllSessions } from "@/utils/auth";
import { initGA, initMixpanel } from '@/analytics/analytics';

// Set up axios interceptor to handle 401 errors globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      // Clear all auth sessions
      clearAllSessions();
      
      // Redirect to login page if not already there
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    
    // Return the error so it can still be handled by specific error handlers if needed
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Read env values from runtime-injected window.__ENV (preferred) or build-time process.env
const runtimeEnv = (typeof window !== 'undefined' && window.__ENV) || {};
const REACT_APP_GA_MEASUREMENT_ID = runtimeEnv.REACT_APP_GA_MEASUREMENT_ID || process.env.REACT_APP_GA_MEASUREMENT_ID;
const REACT_APP_MIXPANEL_TOKEN = runtimeEnv.REACT_APP_MIXPANEL_TOKEN || process.env.REACT_APP_MIXPANEL_TOKEN;

// Log the loaded env values. These logs appear in the browser DevTools Console (Console tab).
console.log('Loaded env vars (source: window.__ENV || process.env):', {
  REACT_APP_GA_MEASUREMENT_ID,
  REACT_APP_MIXPANEL_TOKEN,
});

// Warn if .env values are missing (helps detect when runtime injection failed)
if (!REACT_APP_GA_MEASUREMENT_ID && !REACT_APP_MIXPANEL_TOKEN) {
  console.warn('Missing env vars: REACT_APP_GA_MEASUREMENT_ID and REACT_APP_MIXPANEL_TOKEN. Ensure the container generates /env.js from env vars.');
} else {
  if (!REACT_APP_GA_MEASUREMENT_ID) {
    console.warn('Missing env var: REACT_APP_GA_MEASUREMENT_ID. Google Analytics will not be initialized.');
  }
  if (!REACT_APP_MIXPANEL_TOKEN) {
    console.warn('Missing env var: REACT_APP_MIXPANEL_TOKEN. Mixpanel will not be initialized.');
  }
}

// Initialize Google Analytics / Mixpanel using resolved env values
try {
  initGA(REACT_APP_GA_MEASUREMENT_ID);
} catch (e) {}
try {
  initMixpanel(REACT_APP_MIXPANEL_TOKEN);
} catch (e) {}

// Register service worker for offline capability
// Only registers in production builds
registerServiceWorker().catch((error) => {
  console.error("Failed to register service worker:", error);
});
